import { DataBean } from "../DataBean";

export class EmployeeBenefit extends DataBean {

    public async deleteEmployeeBenefit(idEmployeeBenefit: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteEmployeeBenefit_Number", [idEmployeeBenefit]);
    }

    public async getEmployeeBenefit(idEmployeeBenefit: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.employees.EmployeeBenefit_getEmployeeBenefit_Number", [idEmployeeBenefit]);
    }

    public async getEmployeeBenefitCatalog(idCountries: number, regex: string, page: number, recordsPerPage: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getEmployeeBenefitCatalog_Number_String_Number_Number", [idCountries, regex, page, recordsPerPage]);
    }

    public async updateEmployeeBenefit(bean: any): Promise<any> {
        return this.getCustomService(
            "QuickDataERPCore",
            "com.quickdataerp.bean.employees.EmployeeBenefit_updateEmployeeBenefit_com.quickdataerp.bean.employees.EmployeeBenefit",
            [
                {
                    "DataBeanProperties": bean,
                    "DataBeanName": "com.quickdataerp.bean.employees.EmployeeBenefit"
                }
            ]
        );
    }

    public async updatetEmployeeBenefitsForCountry(idCountries: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_updatetEmployeeBenefitsForCountry_Number", [idCountries]);
    }

}
